module.exports = __webpack_public_path__ + "static/media/TasklyCardSort.8a89e62d.png";